module.exports = __webpack_public_path__ + "ca41ca8970d758fb937c8e04e82620e9.svg";